import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SortUtilService {
  sortByFirstNumber(data: string[]): string[] {
    return [...data].sort((a, b) => {
      const getFirstNumber = (str: string) => {
        const match = str.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
      };

      const numA = getFirstNumber(a);
      const numB = getFirstNumber(b);

      if (numA !== numB) {
        return numA - numB;
      }

      // If numbers are equal, fall back to alphabetical sort
      return a.localeCompare(b);
    });
  }
}
